export default __webpack_public_path__ + "static/home-products-bg-baeccaaf651de83981ca739a2e219082.png";